import "./Home.module.css";
import ThePulseHeader from "@/reusable_sections/Header";
import PremiumLogisticsHub from "./sections/PremiumLogisticsHub";
import HowItWorks from "./sections/HowItWorks";
import TheVendiTrustPillars from "./sections/TheVendiTrustPillars";
import OurGlobalPresence from "./sections/OurGlobalPresence";
import CommonTechInquiries from "./sections/CommonTechInquiries";
import InputText from "./sections/InputText";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <ThePulseHeader />
      <PremiumLogisticsHub />
      <HowItWorks />
      <TheVendiTrustPillars />
      <OurGlobalPresence />
      <CommonTechInquiries />
      <InputText />
      <Footer />
    </div>;
}